import { useState, useEffect, createContext } from "react";
import { AxiosResponse } from "axios";
import { apiUrls } from "../../utils/apiUrls";
import { getData, convertDate } from "../../utils/reusables";
import {
  typeFormDto,
  typeCountryDto,
  regulationContextTypes,
  countryDataTypes,
  typeApiResponse,
} from "../../utils/typeDefs";

const RegulationContext = createContext<regulationContextTypes | null>(null);

type regulationProps = {
  children: JSX.Element;
};

const RegulationContextProvider = ({ children }: regulationProps) => {
  const [regulationPageData, setRegulationPageData] = useState<
    typeFormDto[] | [] | null
  >(null);
  const [regulationCountryData, setRegulationCountryData] = useState<
    typeCountryDto[] | []
  >([]);
  const [sortedCountryData, setSortedCountryData] = useState<
    typeCountryDto[] | []
  >([]);
  const [currentCountryId, setCurrentCountryId] = useState<number | null>(null);
  const [currentId, setCurrentId] = useState<number | null>(null);

  const [currentRowData, setCurrentRowData] = useState<typeFormDto | null>(
    null
  );

  useEffect(() => {
    getData(apiUrls.country.base).then(
      (result: AxiosResponse<countryDataTypes & typeApiResponse>) =>
        setRegulationCountryData(result.data.data)
    );
  }, []);

  useEffect(() => {
    if (regulationCountryData.length > 0) {
      const sortedCountryData = regulationCountryData.sort(
        (a: typeCountryDto, b: typeCountryDto) => (a.name > b.name ? 1 : -1)
      );

      setSortedCountryData(sortedCountryData);
    }
  }, [regulationCountryData]);

  useEffect(() => {
    if (currentCountryId !== null) {
      getData(apiUrls.regulation.getRegulations(currentCountryId)).then(
        (result: AxiosResponse<typeFormDto[] & typeApiResponse>) => {
          setRegulationPageData(result.data);
        }
      );
    } else setRegulationPageData([]);
  }, [currentCountryId]);

  useEffect(() => {
    if (regulationPageData && regulationPageData.length > 0) {
      regulationPageData.forEach((item) => {
        item.entryIntoForce = convertDate(item.entryIntoForce);
        item.lastReview = convertDate(item.lastReview);
      });

      setRegulationPageData(regulationPageData);
    }
  }, [regulationPageData]);

  useEffect(() => {
    if (currentId) {
      getData(apiUrls.regulation.getRegulationById(currentId)).then(
        (result) => {
          if (result.status === 200) {
            setCurrentRowData(result.data);
            return true;
          } else return false;
        }
      );
    }
  }, [currentId]);

  return (
    <RegulationContext.Provider
      value={{
        regulationPageData,
        setRegulationPageData,
        sortedCountryData,
        setRegulationCountryData,
        currentCountryId,
        setCurrentCountryId,
        setCurrentId,
        currentRowData,
      }}
    >
      {children}
    </RegulationContext.Provider>
  );
};

export { RegulationContextProvider, RegulationContext };
